/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseListMaintenanceScheduleResponse } from '../models/ApiResponseListMaintenanceScheduleResponse';
import type { ApiResponseMaintenanceScheduleResponse } from '../models/ApiResponseMaintenanceScheduleResponse';
import type { ApiResponseVoid } from '../models/ApiResponseVoid';
import type { CreateSestMaintenanceScheduleRequest } from '../models/CreateSestMaintenanceScheduleRequest';
import type { UpdateSestMaintenanceScheduleRequest } from '../models/UpdateSestMaintenanceScheduleRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class MaintenancesScheduleControllerService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * 소모품 관리주기 업데이트
   * 소모품 관리주기를 업데이트합니다.
   * @returns ApiResponseVoid OK
   * @throws ApiError
   */
  public updateSestMaintenanceSchedule({
    vin,
    sestCode,
    requestBody,
  }: {
    vin: string,
    sestCode: '01' | '02' | '03' | '04' | '09' | '18' | '21',
    requestBody: UpdateSestMaintenanceScheduleRequest,
  }): CancelablePromise<ApiResponseVoid> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/maintenances/cars/{vin}/sest/{sestCode}/schedule/',
      path: {
        'vin': vin,
        'sestCode': sestCode,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 소모품 관리주기 등록
   * 소모품 관리주기를 등록합니다.
   * @returns ApiResponseVoid OK
   * @throws ApiError
   */
  public createSestMaintenanceSchedule({
    vin,
    sestCode,
    requestBody,
  }: {
    vin: string,
    sestCode: '01' | '02' | '03' | '04' | '09' | '18' | '21',
    requestBody: CreateSestMaintenanceScheduleRequest,
  }): CancelablePromise<ApiResponseVoid> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/maintenances/cars/{vin}/sest/{sestCode}/schedule/',
      path: {
        'vin': vin,
        'sestCode': sestCode,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 소모품 관리주기 삭제
   * 소모품 관리주기를 삭제합니다.
   * @returns ApiResponseVoid OK
   * @throws ApiError
   */
  public deleteSestMaintenanceSchedule({
    vin,
    sestCode,
  }: {
    vin: string,
    sestCode: '01' | '02' | '03' | '04' | '09' | '18' | '21',
  }): CancelablePromise<ApiResponseVoid> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/maintenances/cars/{vin}/sest/{sestCode}/schedule/',
      path: {
        'vin': vin,
        'sestCode': sestCode,
      },
    });
  }
  /**
   * 특정 소모품 관리주기 조회
   * 특정 소모품의 현재 관리주기를 조회합니다.
   * @returns ApiResponseMaintenanceScheduleResponse OK
   * @throws ApiError
   */
  public getMaintenanceSchedule1({
    vin,
    sestCode,
  }: {
    vin: string,
    sestCode: string,
  }): CancelablePromise<ApiResponseMaintenanceScheduleResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/maintenances/cars/{vin}/sest/{sestCode}/schedule',
      path: {
        'vin': vin,
        'sestCode': sestCode,
      },
    });
  }
  /**
   * 소모품 관리주기 업데이트
   * 소모품 관리주기를 업데이트합니다.
   * @returns ApiResponseVoid OK
   * @throws ApiError
   */
  public updateSestMaintenanceSchedule1({
    vin,
    sestCode,
    requestBody,
  }: {
    vin: string,
    sestCode: '01' | '02' | '03' | '04' | '09' | '18' | '21',
    requestBody: UpdateSestMaintenanceScheduleRequest,
  }): CancelablePromise<ApiResponseVoid> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/maintenances/cars/{vin}/sest/{sestCode}/schedule',
      path: {
        'vin': vin,
        'sestCode': sestCode,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 소모품 관리주기 등록
   * 소모품 관리주기를 등록합니다.
   * @returns ApiResponseVoid OK
   * @throws ApiError
   */
  public createSestMaintenanceSchedule1({
    vin,
    sestCode,
    requestBody,
  }: {
    vin: string,
    sestCode: '01' | '02' | '03' | '04' | '09' | '18' | '21',
    requestBody: CreateSestMaintenanceScheduleRequest,
  }): CancelablePromise<ApiResponseVoid> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/maintenances/cars/{vin}/sest/{sestCode}/schedule',
      path: {
        'vin': vin,
        'sestCode': sestCode,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 소모품 관리주기 삭제
   * 소모품 관리주기를 삭제합니다.
   * @returns ApiResponseVoid OK
   * @throws ApiError
   */
  public deleteSestMaintenanceSchedule1({
    vin,
    sestCode,
  }: {
    vin: string,
    sestCode: '01' | '02' | '03' | '04' | '09' | '18' | '21',
  }): CancelablePromise<ApiResponseVoid> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/maintenances/cars/{vin}/sest/{sestCode}/schedule',
      path: {
        'vin': vin,
        'sestCode': sestCode,
      },
    });
  }
  /**
   * 특정 소모품 관리주기 조회
   * 특정 소모품의 현재 관리주기를 조회합니다.
   * @returns ApiResponseMaintenanceScheduleResponse OK
   * @throws ApiError
   */
  public getMaintenanceSchedule({
    vin,
    sestCode,
  }: {
    vin: string,
    sestCode: string,
  }): CancelablePromise<ApiResponseMaintenanceScheduleResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/maintenances/cars/{vin}/sest/{sestCode}schedule/',
      path: {
        'vin': vin,
        'sestCode': sestCode,
      },
    });
  }
  /**
   * 소모품 관리주기 목록 조회
   * 소모품 관리주기 목록을 조회합니다.
   * @returns ApiResponseListMaintenanceScheduleResponse OK
   * @throws ApiError
   */
  public getMaintenanceScheduleList({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<ApiResponseListMaintenanceScheduleResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/maintenances/cars/{vin}/sest/-/schedule',
      path: {
        'vin': vin,
      },
    });
  }
  /**
   * 소모품 관리주기 목록 조회
   * 소모품 관리주기 목록을 조회합니다.
   * @returns ApiResponseListMaintenanceScheduleResponse OK
   * @throws ApiError
   */
  public getMaintenanceScheduleList1({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<ApiResponseListMaintenanceScheduleResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/maintenances/cars/{vin}/sest/-/schedule/',
      path: {
        'vin': vin,
      },
    });
  }
}
